if (!customElements.get('sizeguide-toggle')) {
  class SizeguideToggle extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(event) {
      event.preventDefault();

      document.dispatchEvent(new CustomEvent('sizeguide:toggle'));
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }
  }

  customElements.define('sizeguide-toggle', SizeguideToggle);
}

if (!customElements.get('sizeguide-drawer')) {
  class SizeguideDrawer extends HTMLElement {
    constructor() {
      super();

      this.handleToggleRef = this.handleToggle.bind(this);
      this.isToggling = false;
    }

    handleToggle() {
      if (this.isToggling) return;

      this.isToggling = true;

      const isOpen = this.classList.contains('is-open');

      if (isOpen) {
        this.classList.remove('is-open');
        if (typeof bodyScroll !== 'undefined') {
          bodyScroll.unlock(this);
        }
      } else {
        this.classList.add('is-open');
        if (typeof bodyScroll !== 'undefined') {
          bodyScroll.lock(this);
        }
      }

      setTimeout(() => {
        this.isToggling = false;
      }, 50);
    }

    wrapTables() {
      const tables = this.querySelectorAll('table');

      tables.forEach(function (table) {
        if (!table.parentElement.classList.contains('table-responsive')) {
          const wrapper = document.createElement('div');
          wrapper.className = 'table-responsive';

          table.replaceWith(wrapper);
          wrapper.appendChild(table);
        }
      });
    }

    disconnectedCallback() {
      document.removeEventListener('sizeguide:toggle', this.handleToggleRef);
    }

    connectedCallback() {
      document.addEventListener('sizeguide:toggle', this.handleToggleRef);

      this.wrapTables();

      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
      }
    }
  }

  customElements.define('sizeguide-drawer', SizeguideDrawer);
}
